import { createAction, createReducer } from "redux-act";
import produce from "immer";
import { reducerRegistry } from "../reducerRegistry";
import { GridSetting, LegendSetting, PrintRectangle, PrintSettings } from "../../interfaces/print";

export type PrintState = {
  rectangle?: PrintRectangle;
  settings?: PrintSettings;
  enabled?: boolean;
};

export const reducerName = "print";
export const initialSettings: PrintSettings = {
  title: "",
  withScale: false,
  grid: null,
  legend: null,
};

const initialState: PrintState = {
  enabled: false,
  rectangle: {},
  settings: initialSettings,
};

export const reducer = createReducer({}, initialState);
export const setPrintTitle = createAction<string>("print/set-title");
export const setPrintRectangle = createAction<PrintRectangle>("print/set-rectangle-position");
export const toggleScaleSetting = createAction("print/toggle-scale-setting");
export const setGrid = createAction<GridSetting | null>("print/set-grid");
export const setLegend = createAction<LegendSetting | null>("print/set-legend");
export const setPrintEnabled = createAction<boolean>("print/set-enabled");

reducer.on(
  setPrintEnabled,
  produce((state: PrintState, enabled: boolean) => {
    state.enabled = enabled;
  }),
);

reducer.on(
  setPrintRectangle,
  produce((state: PrintState, rectangle: PrintRectangle) => {
    state.rectangle = rectangle;
  }),
);

reducer.on(
  setPrintTitle,
  produce((state: PrintState, title: string) => {
    state.settings.title = title;
  }),
);

reducer.on(
  toggleScaleSetting,
  produce((state: PrintState) => {
    state.settings.withScale = !state.settings.withScale;
  }),
);

reducer.on(
  setGrid,
  produce((state: PrintState, grid: GridSetting) => {
    const gridState = state.settings.grid;

    state.settings.grid = grid ? { ...gridState, ...grid } : null;
  }),
);

reducer.on(
  setLegend,
  produce((state: PrintState, legend: LegendSetting) => {
    const legendState = state.settings.legend;

    state.settings.legend = legend ? { ...legendState, ...legend } : null;
  }),
);

reducerRegistry.register(reducerName, reducer);
